<template>
  <Modal :id="'cmp-booking-booking-sidewindow-load_task_list_form'" @cancelled="onCancel">
    <template slot="header">{{ $t('load_tasks') }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <Dropdown
            :options="artistTV"
            class="m2"
            :selected="artistSelectedTV"
            :placeholder="$t('artist')"
            v-on:selectedChange="(e) => onDropdownChange('calendar_date_artist_ids', e)"
            :listHeight="120"
            box
            multiple
            required
            showValidationIcons
            @validated="(e) => onValidation('calendar_date_artist_ids', e)"
          ></Dropdown>
          <Dropdown
            :id="'task_group_id'"
            class="m2"
            :options="taskGroupTV"
            :selected="taskGroupTV.find((b) => b.value == formValues.task_group_id)"
            :placeholder="$t('task_group')"
            box
            @selectedChange="(b) => onDropdownChange('task_group_id', b)"
            required
            showValidationIcons
            @validated="(e) => onValidation('task_group_id', e)"
          ></Dropdown>
        </div>
      </div>
    </template>
    <div></div>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel"> {{$t('cancel')}} </button>
      <button
        :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onOkClick"
      >
         {{$t('ok')}} 
      </button>
    </template>
  </Modal>
</template>

<script>
import { createTV } from "../../../../models/text-value.model";
import { BookingSettingsService } from "../../../../modules/settings/services/booking-settings.service";
import { wait } from "../../../../utility";
import { taskService } from "../../../tasks/services/tasks.service";

export default {
  components: {
  },
  props: ["booking"],
  data() {
    return {
      formValues: { calendar_date_artist_ids: "", task_group_id: "" },
      validationResult: {},
      taskTemplateGroups: {},
    };
  },
  mounted() {
    this.loadTaskTemplateGroups();
  },
  mixins: [],

  computed: {
    isFormValid: function () {
      const values = Object.values(this.validationResult);
      return values.length == 2 && values.every((e) => e.valid);
    },
    taskGroupTV: function () {
      return createTV(this.taskTemplateGroups, "task_template_group", "task_group_id");
    },
    artistTV: function () {
      return createTV(this.booking.artists, "artist_name", "calendar_date_artist_id");
    },
    artistSelectedTV() {
      const ldtArr = this.formValues.calendar_date_artist_ids
        ? this.formValues.calendar_date_artist_ids.split(",")
        : [];
      return this.artistTV.filter((ldtTV) => ldtArr.includes("" + ldtTV.value)) || [];
    },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    loadTaskTemplateGroups: async function () {
      //const result = await BookingSettingsService.findBookingTaskSettingsVal();
      
      const result  =  await taskService.taskTemplateGroup('booking');
      
      this.taskTemplateGroups = result.data.booking_task_template_groups;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange(name, value) {
      let val = value.value;
      if (["calendar_date_artist_ids"].includes(name)) {
        val = value.map((r) => r.value).join();
      }
      this.formValues[name] = val;
    },
    onOkClick: async function () {
      this.$emit("submitted", this.formValues);
      // await wait(2000);
      this.onCancel();
    },
  },
};
</script>

<style lang="scss">
</style>
